import { IMaterial } from "types/Material";
import {
  displayNameForUnitOfMeasure,
  IDisplayQuantity,
  MeasurementUnit,
} from "types/MeasurementUnit";

export const isUnitGmsOrMl = (unitOfMeasure: MeasurementUnit) => {
  if (
    unitOfMeasure === MeasurementUnit.GRAMS ||
    unitOfMeasure === MeasurementUnit.MILLI_LITRE
  ) {
    return true;
  }

  return false;
};

export const isUnitKgsOrLtr = (unit: MeasurementUnit) => {
  return unit === MeasurementUnit.KILOGRAMS || unit === MeasurementUnit.LITRE;
};

export const decorateDisplayUnit = (material: IMaterial) => {
  if (!isUnitGmsOrMl(material.unitOfMeasure)) {
    if (material.displayUnitOfMeasure) {
      return material.displayUnitOfMeasure;
    } else {
      return displayNameForUnitOfMeasure(material.unitOfMeasure);
    }
  }

  if (material.unitOfMeasure === MeasurementUnit.GRAMS) {
    return "kgs";
  }

  if (material.unitOfMeasure === MeasurementUnit.MILLI_LITRE) {
    return "ltrs";
  }

  return "";
};

// Quantities for gms/ml materials are entered in kgs/ltrs (same convention as
// the purchase-order form). These two helpers keep the entry label and the
// entry value derived from the same unit, so they can never disagree.
export const entryUnitLabelForUnitOfMeasure = (
  unitOfMeasure: MeasurementUnit
) => {
  if (unitOfMeasure === MeasurementUnit.GRAMS) {
    return "kgs";
  }

  if (unitOfMeasure === MeasurementUnit.MILLI_LITRE) {
    return "ltrs";
  }

  return displayNameForUnitOfMeasure(unitOfMeasure);
};

export const toEntryQuantity = (
  displayQuantity: IDisplayQuantity,
  unitOfMeasure: MeasurementUnit
) => {
  if (!isUnitGmsOrMl(unitOfMeasure)) {
    // already shown in the unit it is entered in
    return displayQuantity.quantity;
  }

  // the backend promotes gms/ml to kgs/ltrs past 1000, so only scale down when
  // it did not
  return isUnitKgsOrLtr(displayQuantity.unit)
    ? displayQuantity.quantity
    : displayQuantity.quantity / 1000;
};
